export default {
  publicationBooking: {
    include_publication_booking_brand_group: true,
    include_publication_booking_layout_artwork: true,
    include_publication_booking_preflighted_by: true,
    include_publication_booking_publication: true,
    include_publication_booking_publication_edition: true,
    include_publication_booking_publication_product: true,
  },
}
